import products from 'redux/middleware/analytics/actions-to-track/products-and-components/grids/interstitials-products';
import navigation from './navigation';

export default state => [navigation(state), products(state)];
